import { EntityKind } from 'mdello-client-ts/dist/src/interfaces/admin/entity.interface';
import { useMutation } from 'react-query';
import { LocalStorageKey } from 'src/localStorage/enums/localStorageKey.enum';
import { getDataFromLocalStorage } from 'src/localStorage/getDataFromLocalStorage';
import { useNotification } from 'src/providers/notificationsProvider';
import { Project } from 'src/services/napi/projects/interfaces/fetchProjects.interface';
import { getClient } from 'src/util/mdello-instance';
import { CreateEventData } from './interfaces/events.interface';
import { UseAddContentModelMutationParams } from '../contentModels/mutations/useAddContntModelMutation/interfaces/useAddContentModelMutation.interface';

const createEvent = async (data: CreateEventData) => {
  const currentProject = getDataFromLocalStorage<Project>(LocalStorageKey.CURRENT_PROJECT);

  if (!currentProject?._id) return;

  getClient()?.createEntity({ kind: EntityKind.EVENT, projectId: currentProject._id }, data);
};

export const useCreateEvent = ({ onError, onSuccess }: UseAddContentModelMutationParams) => {
  const { notify } = useNotification();

  return useMutation((data: CreateEventData) => createEvent(data), {
    onError: () => {
      notify({ message: 'Error Loading data... Try again later', severity: 'error' });
      if (onError) {
        onError();
      }
    },
    onSuccess: () => {
      notify({ message: 'Notification Created Successfully' });
      if (onSuccess) {
        onSuccess();
      }
    }
  });
};
